<template>
  <section>
    <div class="container content-padding bonus-container">
      <template v-if="isEditing">
        <div class="row">
          <div class="col-12 text-center">
            <h2 class="mt-5">ขออภัยในความไม่สะดวก</h2>
            <h3>{{ editingRemark }}</h3>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="row">
          <div class="col-12 text-center">
            <h2 class="bonus-title">เก็บงานเพลิน รับเงินปัง!!</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="bonus-card">
              <div class="bonus-header">
                <div class="bonus-header-title">
                  <p>สถานะของฉัน</p>
                </div>
                <div class="bonus-header-icon">
                  <i class="fal fa-exclamation-circle alert-icon" @click="openDescModal"></i>
                </div>
              </div>
              <div class="bonus-target">
                <img src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/bonus/target.gif" alt="bonus-target" />
              </div>
              <div class="bonus-hours">
                <p class="bonus-total-hours">{{ hours }} ชั่วโมง</p>
                <p class="bonus-hours-desc">ชั่วโมงที่คุณสะสมได้ในกิจกรรมนี้ <span class="bonus-hours-desc-detail">(จาก {{ orderQty }} งาน)</span></p>
              </div>
              <hr />
              <div class="bonus-progress-final" v-if="getCurrentBonusIndex() === bonuses.length - 1">
                <p>
                  <span>ยินดีด้วยคุณได้รับโบนัสใหญ่</span>
                </p>
              </div>
              <div class="bonus-progress" v-else>
                <p>
                  สะสมอีก <span class="bonus-progress-highlight">{{ getNextHoursFromCurrentHours() }}</span> ชั่วโมง 
                  <span v-if="getCurrentBonusIndex() === -1">เพื่อรับโบนัสจากเรา</span>
                  <span v-else> อัพเกรดโบนัสเป็น <span class="bonus-progress-highlight">{{ getNextBonus() ? getNextBonus().short_title : '-' }}</span> บาท</span> 
                </p> 
              </div>
              <div class="bonus-progress-bar">
                <div class="progress-track">
                  <div class="progress-bg"></div> <!-- background เต็ม -->
                  <div class="progress-waiting" :style="{ width: calculateHourPercentage(unConfirmedHours) + '%' }"></div> <!-- งานรอดำเนินการ -->
                  <div class="progress-confirmed" :style="{ width: calculateHourPercentage(hours) + '%' }"></div> <!-- งานยืนยันแล้ว -->

                  <!-- จุดรางวัล -->
                  <div class="reward-point reward-point-start">
                    <img class="reward-icon" src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/bonus/clean-up.gif" alt="icon" />
                  </div>
                  <div class="reward-point" :style="{ left: bonus.percentage + '%' }" v-for="(bonus, index) in bonuses" :key="index">
                    <template v-if="isBonusVisible(index)">
                      <div class="reward-label" :class="{ 'reward-label-active': isCurrentBonus(index), 'reward-label-final': index === bonuses.length - 1 }">{{ bonus.short_title }}</div>
                      <img class="reward-icon" :src="bonus.icon" />
                    </template>
                  </div>
                </div>
              </div>
              <div class="bonus-duration">
                <p>ตั้งแต่วันที่ {{ bonusDuration }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="bonus-warning-card">
              <div class="bonus-warning-card-icon">
                <img src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/bonus/warning.svg" alt="bonus-warning" />
              </div>
              <div class="bonus-warning-card-label">
                <p>คุณจะได้รับรางวัลเฉพาะระดับสูงสุดที่ทำครบเท่านั้น<br />ไม่ใช่รางวัลสะสมทุกระดับ</p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="bonus-detail">
              <div class="bonus-detail-title">
                รายละเอียดโบนัส
              </div>
              <template v-for="(bonus, index) in bonuses">
                <div class="bonus-detail-card" :class="{ 'bonus-detail-card-active': isCurrentBonus(index) && index !== bonuses.length - 1, 'bonus-detail-card-active-final': isCurrentBonus(index) && index === bonuses.length - 1 }" :key="`bonus-card-${index}`" @click.prevent="showBonusDetail(index)" v-if="isBonusVisible(index)">
                  <div class="bonus-detail-card-icon">
                    <img src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/bonus/voucher.svg" alt="bonus-voucher" />
                  </div>
                  <div>
                    <div class="bonus-detail-card-title">
                      {{ bonus.title }}
                    </div>
                    <div class="bonus-detail-card-content">
                      เมื่อรับงานครบ <span class="bonus-detail-card-content-highlight">{{ bonus.hours }}</span> ชั่วโมง
                    </div>
                  </div>
                </div>
                <div class="bonus-detail-card-next" :key="`bonus-card-next-${index}`" v-if="isNextBonusVisible(index)">
                  <div class="bonus-detail-card-next-title">
                    สะสมเพิ่มอีก <span class="bonus-detail-card-next-title-highlight">{{ getNextHoursFromCurrentHours() }}</span> ชั่วโมง เพื่ออัปเกรด<br />โบนัสเป็น <span class="bonus-detail-card-next-title-highlight">{{ getNextBonus() ? getNextBonus().short_title : '-' }}</span> บาท
                  </div>
                  <div class="bonus-detail-card-next-icon">
                    <img src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/bonus/arrow.gif" alt="bonus-arrow" />
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="bonus-terms">
              <div class="bonus-terms-title">
                ข้อกำหนดและเงื่อนไข
              </div>
              <div class="bonus-terms-content">
                <ul>
                  <li>การนับชั่วโมงการทำงานเฉพาะงานที่เข้าให้บริการและกดเสร็จงาน ระหว่างวันที่ {{ bonusDuration }} และต้องไม่มีการแจ้งปัญหา</li>
                  <li>โบนัสจะโอนพร้อมรอบรายได้คุณแม่บ้านในวันที่ {{ paidBonusDate }} และน้ำยา BeNeat และ BeShine จะดำเนินการจัดส่งภายในวันที่ {{ sendBonusDate }}</li>
                  <li>ทางบริษัทจะทำการหัก ณ ที่จ่าย 3% จากยอดโบนัส</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>

    <sweet-modal ref="descModal">
      <div class="bonus-desc">
        <div class="bonus-desc-title">
          คำอธิบายรายละเอียด
        </div>
        <div class="bonus-desc-icon">
          <img src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/bonus/target.gif" alt="bonus-target" />
        </div>
        <div class="bonus-desc-content">
          <div class="bonus-desc-content-title">
            เริ่มอ่านคำอธิบายกัน
          </div>
          <div class="bonus-desc-content-text">
            <img src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/bonus/desc-1.svg" alt="bonus-desc-1" />
            <span>คุณแม่บ้านสะสมชั่วโมงให้ครบ เพื่อรับโบนัสจาก BeNeat</span>
          </div>
          <div class="bonus-desc-content-text">
            <img src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/bonus/desc-2.svg" alt="bonus-desc-2" />
            <span>คุณแม่บ้านจะได้รับการโอนเงินโบนัสตามรอบโอนเงินสัปดาห์ที่ประกาศผล หรือส่งรางวัลโบนัสรอบสัปดาห์ถัดไปหลังจากประกาศผล</span>
          </div>
          <div class="bonus-desc-content-text">
            <img src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/bonus/desc-3.svg" alt="bonus-desc-3" />
            <span>หากคุณแม่บ้าน สะสมชั่วโมงไม่ครบ ตามที่ทางเรากำหนดไว้จะถือว่าไม่ผ่านเกณฑ์การรับรางวัลของ BeNeat</span>
          </div>
          <div class="bonus-desc-content-text">
            <img src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/bonus/desc-4.svg" alt="bonus-desc-4" />
            <span>การนับชั่วโมงการทำงานเฉพาะงานที่เข้าให้บริการและกดเสร็จงานระหว่างวันที่ {{ bonusDuration }} และต้องไม่มีการแจ้งปัญหา</span>
          </div>
        </div>
        <div class="bonus-desc-progress-bar-card">
          <div class="bonus-desc-progress-bar-title">
            อธิบายแถบสถานะ
          </div>
          <div class="bonus-desc-progress-bar-img">
            <img src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/bonus/example-bar-1.svg" alt="example-bar-1" />
          </div>
          <div class="bonus-desc-progress-bar-text">
            <div class="bonus-desc-progress-bar-text-item">
              <span class="bonus-desc-progress-bar-text-item-confirmed"></span><span>คือ งานที่เสร็จแล้ว</span>
            </div>
            <div class="bonus-desc-progress-bar-text-item">
              <span class="bonus-desc-progress-bar-text-item-unconfirmed"></span><span>คือ งานที่ยังไม่เข้าให้บริการ</span>
            </div>
          </div>
        </div>
        <div class="bonus-desc-progress-bar-card">
          <div class="bonus-desc-progress-bar-title">
            การได้รับโบนัส
          </div>
          <div class="bonus-desc-progress-bar-img">
            <img src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/bonus/example-bar-2.svg" alt="example-bar-2" />
          </div>
          <div class="bonus-desc-progress-bar-text">
            <span>คุณจะได้รับรางวัลเฉพาะระดับสูงสุดที่ทำครบเท่านั้น<br />ไม่ใช่รางวัลสะสมทุกระดับ</span>
          </div>
        </div>
      </div>
    </sweet-modal>
  </section>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'
  import { SweetModal } from 'sweet-modal-vue'

  export default {
    data () {
      return {
        isEditing: '',
        bonuses: [
          {
            'title': 'รับน้ำยา BeNeat 3 ขวด + BeShine 1 ขวด',
            'short_title': 'รางวัล',
            'hours': 100,
            'percentage': 25,
            'icon': 'https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/bonus/gift.svg'
          },
          {
            'title': 'รับโบนัส 1,000 บาท',
            'short_title': '1,000',
            'hours': 120,
            'percentage': 50,
            'icon': 'https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/bonus/dollar.svg'
          },
          {
            'title': 'รับโบนัส 2,000 บาท',
            'short_title': '2,000',
            'hours': 140,
            'percentage': 75,
            'icon': 'https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/bonus/dollar.svg'
          },
          {
            'title': 'รับโบนัส 4,000 บาท',
            'short_title': '4,000',
            'hours': 160,
            'percentage': 100,
            'icon': 'https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/bonus/dollar-alt.svg'
          }
        ],
        hours: 0,
        unConfirmedHours: 0,
        orderQty: 0,
        bonusDuration: '-',
        paidBonusDate: '-',
        sendBonusDate: '-',
        queryData: {
          professional_id: this.$route.params.id,
          month: this.$route.query.month ? this.$route.query.month : moment().month() + 1,
          year: this.$route.query.year ? this.$route.query.year : moment().year()
        }
      }
    },
    components: {
      SweetModal
    },
    methods: {
      calculateHourPercentage (hours) {
        if (!this.bonuses.length) {
          return 0
        }
        const currentBonusIndex = this.getCurrentBonusIndexFromHours(hours)
        if (currentBonusIndex === -1) {
          const firstBonus = this.bonuses[0]
          return (hours / firstBonus.hours) * firstBonus.percentage
        } else if (currentBonusIndex === this.bonuses.length - 1) {
          return 100
        }
        const currentBonus = this.bonuses[currentBonusIndex]
        const nextBonus = this.bonuses[currentBonusIndex + 1]
        return currentBonus.percentage + ((hours - currentBonus.hours) / (nextBonus.hours - currentBonus.hours)) * (nextBonus.percentage - currentBonus.percentage)
      },
      getCurrentBonusIndex () {
        let currentBonusIndex = -1
        for (let i = 0; i < this.bonuses.length; i++) {
          const bonus = this.bonuses[i]
          currentBonusIndex = i
          if (bonus.hours > this.hours) {
            currentBonusIndex = i - 1
            break
          }
        }
        return currentBonusIndex
      },
      getCurrentBonusIndexFromHours (hours) {
        let currentBonusIndex = -1
        for (let i = 0; i < this.bonuses.length; i++) {
          const bonus = this.bonuses[i]
          currentBonusIndex = i
          if (bonus.hours > hours) {
            currentBonusIndex = i - 1
            break
          }
        }
        return currentBonusIndex
      },
      isCurrentBonus (index) {
        const currentBonusIndex = this.getCurrentBonusIndex()
        return index === currentBonusIndex
      },
      isBonusVisible (index) {
        const currentBonusIndex = this.getCurrentBonusIndex()
        return index >= currentBonusIndex
      },
      isNextBonusVisible (index) {
        if (index === this.bonuses.length - 1) {
          return false
        }
        const currentBonusIndex = this.getCurrentBonusIndex()
        return index === currentBonusIndex
      },
      getNextBonus () {
        const currentBonusIndex = this.getCurrentBonusIndex()
        if (currentBonusIndex === -1) {
          return null
        }
        if (currentBonusIndex === this.bonuses.length - 1) {
          return null
        }
        return this.bonuses[currentBonusIndex + 1]
      },
      getNextHours (index) {
        if (index === this.bonuses.length - 1) {
          return 0
        }
        const bonus = this.bonuses[index]
        const nextBonus = this.bonuses[index + 1]
        const hours = bonus.hours
        const nextHours = nextBonus.hours

        return nextHours - hours
      },
      getNextHoursFromCurrentHours () {
        const currentBonusIndex = this.getCurrentBonusIndex()
        if (currentBonusIndex === -1) {
          return this.bonuses[0].hours - this.hours
        }
        const nextBonus = this.getNextBonus()
        if (!nextBonus) {
          return 0
        }
        return nextBonus.hours - this.hours
      },
      showBonusDetail (index) {
        const bonus = this.bonuses[index]
        this.$swal({
          showCloseButton: true,
          showConfirmButton: false,
          html: `
            <div style="text-align: center; padding: 8px 12px; position: relative;">
              <img src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/bonus/voucher.svg" alt="bonus" style="width: 80px; height: auto; margin-bottom: 16px;" />
              <div style="font-size: 16px; margin-bottom: 4px;">สะสมชั่วโมงการทำงานครบ <b style="color: #2f7e00;">${bonus.hours}</b> ชั่วโมง</div>
              <div style="font-size: 16px; color: #666; margin-bottom: 12px;">เพื่อรับรางวัล</div>
              <div style="font-size: 16px; font-weight: 600; color: #2f7e00;">${bonus.title}</div>
            </div>
          `
        })
      },
      hideBonusDetail () {
        this.$swal.close()
      },
      openDescModal () {
        this.$refs.descModal.open()
      },
      async loadProfessionalBonus (queryData) {
        this.$swal({
          title: 'ระบบกำลังประมวลผล',
          text: 'กรุณารอสักครู่ค่ะ',
          allowOutsideClick: true
        })
        this.$swal.showLoading()
        const url = `professionals/${queryData.professional_id}/bonus-stats-v2`
        const { data } = await axios.get(url, { params: queryData })
        if (!data.error) {
          this.isEditing = data.is_editing
          this.editingRemark = data.editing_remark
          this.hours = data.completed_order_work_hours ? data.completed_order_work_hours : 0
          this.unConfirmedHours = data.total_work_hours ? data.total_work_hours : 0
          this.orderQty = data.completed_order_qty ? data.completed_order_qty : 0
          this.bonusDuration = data.bonus_duration ? data.bonus_duration : '-'
          this.paidBonusDate = data.paid_bonus_date ? data.paid_bonus_date : '-'
          this.sendBonusDate = data.send_bonus_date ? data.send_bonus_date : '-'
        }
        this.$swal.close()
      }
    },
    mounted () {
      this.loadProfessionalBonus(this.queryData)
    }
  }
</script>


<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Thai+Looped:wght@100..900&display=swap');

.bonus-container {
  font-family: 'Noto Sans Thai Looped';
}

.bonus-title {
  font-weight: 600;
}

.bonus-card {
  padding: 16px 16px 8px 16px;
  border-radius: 12px;
  background-color: white;
  box-shadow: 0 0 24px rgba(0, 188, 212, 0.32);
  color: rgba(48, 59, 71, 1);

  .bonus-header {
    position: relative;

    .bonus-header-title {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      font-weight: 600;
    }

    .bonus-header-icon {
      position: absolute;
      right: 0;
      top: 0;
    }

    .alert-icon {
      color: #ff6b35;
      font-size: 24px;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        color: #e55a2b;
        transform: scale(1.1);
      }
    }
  }

  .bonus-target {
    text-align: center;
    img {
      height: 82px;
    }
  }

  .bonus-hours {
    text-align: center;
    margin-top: 16px;

    .bonus-total-hours {
      font-size: 24px;
      font-weight: 600;
      background-color: rgba(95, 196, 38, 0.08);
      color: rgba(47, 126, 0, 1);
      display: inline-block;
      padding: 12px 14px;
      border-radius: 8px;
      margin-bottom: 8px;
    }

    .bonus-hours-desc {
      font-size: 14px;
      margin-top: 8px;

      .bonus-hours-desc-detail {
        color: rgba(0, 75, 168, 1);
      }
    }
  }

  hr {
    margin: 16px 0;
    border: none;
    border-top: 1px solid rgba(49, 193, 215, 1);
  }

  .bonus-progress {
    font-size: 14px;

    .bonus-progress-highlight {
      font-size: 16px;
      font-weight: 600;
      color: rgba(47, 126, 0, 1);
    }
  }

  .bonus-progress-final {
    font-size: 18px;
    font-weight: 500;
    color: rgba(5, 56, 255, 1);
    text-align: center;
  }

  .bonus-progress-bar {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 48px;

    .progress-label {
      img {
        width: 24px;
        height: 24px;
      }
    }

    .progress-track {
      position: relative;
      flex-grow: 1;
      height: 16px;
      border-radius: 999px;
      overflow: visible;
      background-color: transparent;
      margin-top: 8px;
      margin-right: 16px;

      .progress-bg,
      .progress-waiting,
      .progress-confirmed {
        position: absolute;
        height: 100%;
        border-radius: 999px;
        top: 0;
        left: 0;
      }

      .progress-bg {
        width: 100%;
        background-color: #f1f1f1;
      }

      .progress-waiting {
        background-color: rgba(95, 196, 36, 0.24);
        z-index: 1;
      }

      .progress-confirmed {
        background-color: rgba(95, 196, 36, 1);
        z-index: 2;
      }

      .reward-point {
        position: absolute;
        top: -34px;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 12px;
        transform: translateX(-50%);
        z-index: 3;

        .reward-label {
          font-size: 14px;
          margin-bottom: 6px;

          &.reward-label-final {
            color: rgba(5, 56, 255, 1);
            font-weight: 600;
          }

          &.reward-label-active {
            color: white;
            background-color: rgba(241, 143, 38, 1);
            border-radius: 4px;
            padding: 2px 8px;
            margin-bottom: 2px;
            
            &.reward-label-final {
              background-color: rgba(5, 56, 255, 1);
            }
          }
        }

        .reward-icon {
          width: 32px;
          height: 32px;
        }

        &.reward-point-start {
          left: 6%;
          top: -36px;
        }
      }
    }
  }

  .bonus-duration {
    text-align: center;
    font-size: 14px;
    margin-top: 32px;
  }

}

.bonus-warning-card {
  padding: 16px 16px 8px 16px;
  border-radius: 12px;
  margin-top: 32px;
  background-color: rgba(255, 217, 96, 0.24);
  color: rgba(93, 57, 24, 1);
  

  .bonus-warning-card-icon {
    display: flex;
    justify-content: center;
    img {
      width: 24px;
      height: 24px;
    }
  }

  .bonus-warning-card-label {
    text-align: center;
    font-size: 14px;
    margin-top: 16px;
  } 
}

.bonus-detail {
  margin-top: 32px;

  .bonus-detail-title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 16px;
  }

  .bonus-detail-card {
    font-size: 14px;
    padding: 16px;
    margin-bottom: 8px;
    border-radius: 8px;
    background-color: rgba(243, 243, 243, 1);
    color: rgba(48, 59, 71, 1);
    display: flex;
    align-items: center;
    cursor: pointer;
    overflow: hidden;

    &.bonus-detail-card-active {
      border: 2px solid rgba(241, 143, 38, 1);
      background-color: white;
      position: relative;
      padding-bottom: 32px;

      &::after {
        content: 'โบนัสของคุณล่าสุด';
        position: absolute;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
        background-color: rgba(241, 143, 38, 1);
        color: white;
        font-size: 14px;
        padding: 4px 32px;
        border-radius: 6px;
        white-space: nowrap;
        padding-bottom: 10px;
      }
    }

    &.bonus-detail-card-active-final {
      border: 2px solid rgba(5, 56, 255, 1);
      background-color: white;
      position: relative;
      padding-bottom: 32px;

      &::after {
        content: 'โบนัสของคุณล่าสุด';
        position: absolute;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
        background-color: rgba(5, 56, 255, 1);
        color: white;
        font-size: 14px;
        padding: 4px 32px;
        border-radius: 6px;
        white-space: nowrap;
        padding-bottom: 10px;
      }
    }

    .bonus-detail-card-icon {
      margin-right: 16px;
      img {
        width: 42px;
        height: 42px;
      }
    }

    .bonus-detail-card-title {
      font-weight: 600;
      color: rgba(47, 126, 0, 1);
    }

    .bonus-detail-card-content {
      .bonus-detail-card-content-highlight {
        font-size: 16px;
        font-weight: 600;
      }
    }
  }

  .bonus-detail-card-next {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px;
    gap: 8px;
    justify-items: center;
    border-radius: 8px;
    border: 1px solid rgba(0, 188, 212, 1);
    margin: 8px 0;
    color: rgba(48, 59, 71, 1);

    .bonus-detail-card-next-title {
      font-size: 14px;
      text-align: center;

      .bonus-detail-card-next-title-highlight {
        font-size: 16px;
        font-weight: 600;
        color: rgba(47, 126, 0, 1);
      }
    }

    .bonus-detail-card-next-icon {
      img {
        width: 42px;
        height: 42px;
        transform: rotate(90deg);
      }
    }
  }
}

.bonus-terms {
  margin-top: 16px;

  .bonus-terms-title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 16px;
  }

  .bonus-terms-content {
    font-size: 14px;
    ul {
      list-style-type: disc;
      padding-left: 24px;
    }
  }
}

.bonus-desc {
  color: rgba(48, 59, 71, 1);

  .bonus-desc-title {
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 16px;
  }
  
  .bonus-desc-icon {
    img {
      width: 120px;
      height: 120px;
    }
  }
  
  .bonus-desc-content {
    text-align: left;
    
    .bonus-desc-content-title {
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 16px;
    }
  
    .bonus-desc-content-text {
      display: flex;
      align-items: center;
      gap: 16px;
      margin-bottom: 16px;
      img {
        width: 40px;
        height: 40px;
      }
      span {
        font-size: 16px;
        font-weight: 400;
        color: rgba(62, 62, 62, 1);
      }
    }
  }
}

.bonus-desc-progress-bar-card {
  margin-top: 24px;
  padding: 16px;
  border-radius: 14px;
  background-color: rgba(243, 243, 243, 1);

  .bonus-desc-progress-bar-title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 16px;
  }
  
  .bonus-desc-progress-bar-img {
    margin-bottom: 24px;
    img {
      width: 100%;
    }
  }

  .bonus-desc-progress-bar-text {
    display: flex;
    flex-direction: column;
    gap: 8px;
    font-size: 16px;
    .bonus-desc-progress-bar-text-item {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      .bonus-desc-progress-bar-text-item-confirmed {
        width: 24px;
        height: 24px;
        margin-right: 16px;
        background-color: rgba(95, 196, 36, 1);
        border-radius: 50%;
      }
      .bonus-desc-progress-bar-text-item-unconfirmed {
        width: 24px;
        height: 24px;
        margin-right: 16px;
        background-color: rgba(95, 196, 36, 0.24);
        border-radius: 50%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/professional/ProfessionalBonusV2.vue